import { Injectable } from '@angular/core';
import { Route, Router, UrlSegment, UrlTree } from '@angular/router';
import { QuoteSessionQuery } from '@app/store/session/session.query';
import { ROUTES } from '@constants/routes';
import { firstValueFrom, Observable } from 'rxjs';

@Injectable({
	providedIn: 'root',
})
export class NoQuoteGuard  {
	constructor(
		private readonly session: QuoteSessionQuery,
		private readonly router: Router,
	) { }

	canLoad(
		route: Route,
		segments: UrlSegment[],
	): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
		return firstValueFrom(this.session.session$())
			.then(({ id, quoteDetails }) => {
				if (!id) {
					return this.router.parseUrl(ROUTES.PET_INFORMATION);
				}
				if (quoteDetails?.purchaseSucceeded) {
					return this.router.parseUrl(ROUTES.CONGRATULATIONS);
				}

				return true;
			});
	}

}
